var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpcomingFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#upcomingFilter_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5A5D64",
  d: "M7.17 19.942a.7.7 0 0 1-.33-.309.74.74 0 0 1-.08-.455l1.245-8.465H4.702a.66.66 0 0 1-.304-.064.7.7 0 0 1-.245-.199.73.73 0 0 1-.135-.615L6.07.549a.72.72 0 0 1 .248-.402A.67.67 0 0 1 6.753 0h6.838a.66.66 0 0 1 .295.07.7.7 0 0 1 .238.195.73.73 0 0 1 .137.607l-1.183 5.557h3.248a.69.69 0 0 1 .615.4.74.74 0 0 1-.075.714L7.977 19.685a.7.7 0 0 1-.234.224.66.66 0 0 1-.306.09.7.7 0 0 1-.267-.057"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "upcomingFilter_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgUpcomingFilter;